import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PageWrapper from '../components/PageWrapper';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiPhone, FiMail, FiClock } = FiIcons;

const Contact = () => {
  const [accepted, setAccepted] = useState(false);

  const vCardData = `BEGIN:VCARD
VERSION:3.0
N:Nordblick;Recruiting;;;
FN:Nordblick Recruiting
ORG:Nordblick Recruiting
TEL;TYPE=WORK,VOICE:+491605074395
EMAIL:info@nordblick-recruiting.de
ADR;TYPE=WORK:;;Barmbeker Str. 9a;Hamburg;;22303;Germany
URL:https://nordblick-recruiting.de
END:VCARD`;

  return (
    <PageWrapper className="bg-slate-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-blue-900 mb-4">Kontaktieren Sie uns</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Haben Sie Fragen zu unseren Stellenangeboten oder suchen Sie Personal? Wir sind gerne für Sie da!
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-6 mb-12">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 text-center">
            <SafeIcon icon={FiMapPin} className="h-8 w-8 text-cyan-600 mx-auto mb-3" />
            <h3 className="font-bold text-blue-900 mb-1">Standort</h3>
            <p className="text-slate-600 text-sm">Barmbeker Str. 9a<br />22303 Hamburg</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 text-center">
            <SafeIcon icon={FiPhone} className="h-8 w-8 text-cyan-600 mx-auto mb-3" />
            <h3 className="font-bold text-blue-900 mb-1">Telefon</h3>
            <p className="text-slate-600 text-sm">0160 5074 395</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 text-center">
            <SafeIcon icon={FiMail} className="h-8 w-8 text-cyan-600 mx-auto mb-3" />
            <h3 className="font-bold text-blue-900 mb-1">E-Mail</h3>
            <a href="mailto:info@nordblick-recruiting.de" className="text-cyan-600 text-sm hover:underline break-all">
              info@nordblick-recruiting.de
            </a>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 text-center flex flex-col items-center justify-center">
            <h3 className="font-bold text-blue-900 mb-2">Digitale Visitenkarte</h3>
            <div className="bg-slate-50 p-2 rounded-lg border border-slate-100 mb-2">
              <QRCodeSVG value={vCardData} size={80} />
            </div>
            <p className="text-[10px] text-slate-500">Zum Speichern scannen</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-slate-100 overflow-hidden flex flex-col md:flex-row">
          <div className="p-8 md:p-12 md:w-1/2">
            <h2 className="text-2xl font-bold text-blue-900 mb-6">Schreiben Sie uns</h2>
            <form className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Vorname</label>
                  <input type="text" required className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-cyan-500 focus:border-cyan-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Nachname</label>
                  <input type="text" required className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-cyan-500 focus:border-cyan-500" />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">E-Mail Adresse</label>
                <input type="email" required className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-cyan-500 focus:border-cyan-500" />
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Betreff</label>
                <select className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-cyan-500 focus:border-cyan-500 bg-white">
                  <option>Ich suche Personal (Unternehmen)</option>
                  <option>Ich suche einen Job (Bewerber)</option>
                  <option>Internationale Fachkraft / Migrant</option>
                  <option>Allgemeine Anfrage</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Nachricht</label>
                <textarea rows="4" required className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-cyan-500 focus:border-cyan-500"></textarea>
              </div>

              <div className="flex items-start">
                <input 
                  type="checkbox" 
                  required 
                  checked={accepted}
                  onChange={(e) => setAccepted(e.target.checked)}
                  className="mt-1 h-4 w-4 text-cyan-600 border-slate-300 rounded focus:ring-cyan-500" 
                />
                <label className="ml-2 block text-sm text-slate-600">
                  Ich stimme der Verarbeitung meiner Daten gemäß der{' '}
                  <a href="#/datenschutz" className="text-cyan-600 hover:underline">Datenschutzerklärung</a> zu.
                </label>
              </div>

              <button 
                type="button" 
                disabled={!accepted}
                className="w-full bg-blue-900 text-white font-bold py-3 px-4 rounded-md hover:bg-blue-800 transition-colors disabled:bg-slate-400"
              >
                Nachricht senden
              </button>
            </form>
          </div>
          <div className="md:w-1/2 min-h-[400px]">
            <iframe 
              title="Nordblick Recruiting Standort"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2369.0!2d10.0167!3d53.5894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zQmFybWJla2VyIFN0ci4gOWEsIDIyMzAzIEhhbWJ1cmc!5e0!3m2!1sde!2sde!4v1234567890" 
              width="100%" 
              height="100%" 
              style={{ border: 0, minHeight: '400px' }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Contact;